import React from 'react';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import Prompt from './Prompt';
import wrapField from './wrapField';

const SliderField = ({
  min = 0,
  max = 0,
  field,
  label,
  id = '',
  meta: { touched, error },
  helpers: { setValue },
  sliderLabels,
  sliderValues = sliderLabels,
  disabled = false,
}) => (
  <div className={`${disabled ? 'slider-disabled' : ''}`}>
    <Prompt {...{ label }} />
    <div>
      <div className="slider-wrap" data-tracking-id={id}>
        <Slider
          id={id}
          min={Number(min)}
          max={Number(max)}
          value={
            (sliderValues
              ? Object.values(sliderValues).indexOf(field.value.toString())
              : field.value) || 0
          }
          onChange={(value) => {
            if (disabled) {
              return;
            }
            setValue(sliderValues ? sliderValues[value] : value);
          }}
          labels={sliderLabels}
          format={() => field.value}
        />
      </div>

      {touched && error && <span className="error">{error}</span>}
    </div>
  </div>
);

export default wrapField(SliderField);
